import { Controller } from "@hotwired/stimulus";

// Shows a panel only while a checkbox is checked.
//
//   <div data-controller="checkbox-reveal">
//     <input type="checkbox" data-checkbox-reveal-target="checkbox"
//            data-action="change->checkbox-reveal#sync">
//     <div data-checkbox-reveal-target="panel">...</div>
//   </div>
export default class extends Controller {
  static targets = ["checkbox", "panel"];

  connect() {
    this.sync();
  }

  sync() {
    this.panelTarget.hidden = !this.checkboxTarget.checked;
  }
}
